/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { FlexContainer, Text, theme } from "@nordcloud/gnui";
import { noop } from "~/tools";
import { getNumberFilterValue } from "../helpers";
import { NumberRangeInput } from "../NumberRangeInput";
import { FiltersProp } from "../types";
import { EstateFilterHeader } from "./EstateFilterHeader";

type Props = {
  filters: FiltersProp;
  updateFilters: (input: FiltersProp) => void;
  size?: "m" | "s";
};

export function LifeSpanInput({ filters, updateFilters, size }: Props) {
  return (
    <>
      <EstateFilterHeader onSetSearch={noop} />
      <FlexContainer marginTop={theme.spacing.spacing04}>
        <Text>Specify the life span of the resource activity</Text>
      </FlexContainer>
      <div style={{ whiteSpace: "nowrap" }}>
        <div style={{ display: "inline-block" }}>
          <NumberRangeInput
            from={filters.lifeSpanFrom}
            to={filters.lifeSpanTo}
            size={size}
            onChangeFrom={(value: string) =>
              updateFilters({ lifeSpanFrom: getNumberFilterValue(value) })
            }
            onChangeTo={(value: string) =>
              updateFilters({ lifeSpanTo: getNumberFilterValue(value) })
            }
          />
        </div>
        <span>days</span>
      </div>
    </>
  );
}
